import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import LinkPreviewCard from 'src/components/LinkPreviewCard/LinkPreviewCard';
import calcomCreateEventTypePreview from '../../assets/calcom-create-event-type-preview.png';
import './event-type-naming-callout.scss';

interface EventTypeNamingCalloutProps {
  kindLabel: string;
}

const EventTypeNamingCallout = ({ kindLabel }: EventTypeNamingCalloutProps) => {
  const kindLower: string = kindLabel.toLowerCase();

  return (
    <div className="event-type-naming-callout">
      <Callout
        variant="info"
        title={`Name your ${kindLabel} event type clearly`}
        subtitle={
          <>
            Include the word &ldquo;{kindLower}&rdquo; in its Cal.com name
            (e.g. &ldquo;{kindLabel}&rdquo;) — that&apos;s how Juniper knows the
            link is for {kindLower}s, and it&apos;s what recipients see on the
            invite. Without it, invites read as a vague &ldquo;meeting&rdquo;.
          </>
        }
      >
        <p className="event-type-naming-visibility">
          <strong>
            For now, these booking links are only visible and usable to you.
          </strong>
        </p>

        <LinkPreviewCard
          href="https://cal.com/help/event-types/create-first-event"
          title="Creating & naming event types"
          description="An event type defines a booking's length and availability — name it for its purpose so invites read clearly."
          siteName="Cal.com"
          image={calcomCreateEventTypePreview}
        />
      </Callout>
    </div>
  );
};

export default EventTypeNamingCallout;